module.exports = "<a (click)=\"onSort()\">{{displayName}}</a>\r\n<i class=\"fa fa-caret-up\" aria-hidden=\"true\" *ngIf=\"isUp\"></i>\r\n<i class=\"fa fa-caret-down\" aria-hidden=\"true\" *ngIf=\"!isUp\"></i>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/listView/sortList/sort-list.component.html
// module id = ../../../../../app/shared/components/listView/sortList/sort-list.component.html
// module chunks = main